import React, { useEffect } from "react";
import { useNavigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import { RadioPrime } from "@/components/tv/RadioPrime";

/**
 * Layout minimalista para dashboards de TV
 * - Sem sidebar
 * - Sem header de navegação
 * - Fullscreen (100vw x 100vh)
 * - Apenas validação de autenticação
 */
export function TvLayout() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // O TvLayout também serve os apps fullscreen (/visao-prime-app, /agenda-prime-app,
  // /ecossistema-api-app, popups). O rádio SÓ pode tocar nos painéis de TV.
  const ehPainelTv = location.pathname.startsWith('/tv/');

  useEffect(() => {
    if (!loading && !user) {
      navigate(`/login?returnTo=${encodeURIComponent(window.location.pathname)}`);
    }
  }, [user, loading, navigate]);

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="h-[100dvh] w-[100dvw] overflow-auto bg-background">
      <Outlet />
      {/* Rádio SÓ nos painéis de TV (/tv/*), nunca nos apps fullscreen (Visão
          Prime, Agenda, Ecossistema). Montada UMA vez: sobrevive à rotação
          entre /tv/* sem cortar o som; só um F5 manual pausa. */}
      {ehPainelTv && <RadioPrime />}
    </div>
  );
}
